<template>
    <v-form v-model="$storeDemandeBourse.ValidParcoursCpge" ref="refParcoursCpge" lazy-validation>
        <v-row>
            <v-col cols="6">
                <v-autocomplete 
                    label="Année scolaire CPGE" 
                    v-model="$storeDemandeBourse.DonneesFormulaire.AnneeScolaireCpge"
                    item-text="lang00"
                    item-value="id"
                    :items="$storeCatalogue.AnneeScolaire"
                    :clearable="!$storeDemandeBourse.ReadOnly"
                    :readonly="$storeDemandeBourse.ReadOnly"
                    :rules="$storeReglesBourse.obligatoire"
                    ref="anneescocpge"
                ></v-autocomplete>
            </v-col>
            <v-col cols="6"></v-col>
        </v-row>
        <v-row>
            <v-col cols="3">
                <v-autocomplete 
                    label="Année CPGE" 
                    v-model="$storeDemandeBourse.DonneesFormulaire.AnneeCpge"
                    item-text="lang00"
                    item-value="id"
                    :items="$storeCatalogue.AnneeCpge2eAnnee"
                    :clearable="!$storeDemandeBourse.ReadOnly"
                    :readonly="$storeDemandeBourse.ReadOnly"
                    :rules="$storeReglesBourse.obligatoire"
                    ref="anneecpge"
                    @change="ChangementAnneeCpge"
                ></v-autocomplete>
            </v-col>
            <v-col cols="3">
                <v-autocomplete 
                    label="Filière" 
                    v-model="$storeDemandeBourse.DonneesFormulaire.FiliereAnnee2"
                    item-text="lang00"
                    item-value="id"
                    :items="$storeCatalogue.Filiere2eAnnee"
                    :clearable="!$storeDemandeBourse.ReadOnly"
                    :readonly="$storeDemandeBourse.ReadOnly"
                    :rules="$storeReglesBourse.obligatoire"
                    ref="filiere"
                ></v-autocomplete>
            </v-col>
            <v-col cols="3">
                <v-autocomplete 
                    label="Etablissement CPGE" 
                    v-model="$storeDemandeBourse.DonneesFormulaire.EtablissementCpge"
                    item-text="label"
                    item-value="idCrypte"
                    :items="$storeDemandeBourse.ListeEtablissementsCpgeEnCours"
                    :clearable="!$storeDemandeBourse.ReadOnly"
                    :readonly="$storeDemandeBourse.ReadOnly"
                    :rules="$storeReglesBourse.obligatoire"
                    ref="etabcpge"
                    @change="EtablissementCpgeChange"
                ></v-autocomplete>
            </v-col>
            <v-col cols="3">
                <v-text-field
                    label="Type d'établissement"
                    :value="TypeEtablissementCpge"
                    disabled
                ></v-text-field>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <h4>Cliquer sur "Ajouter" pour renseigner les années antérieures de votre parcours CPGE.</h4>
            </v-col>
        </v-row>
        <v-layout row wrap xs12>
            <!-- debut dialog -->
            <v-dialog v-model="dialog" max-width="70%">
                <template v-slot:activator="{ on }">
                    <v-layout class="btn-dialog" align-start justify-end>
                        <v-btn 
                        dark 
                        v-on="on"
                        v-show="!$storeDemandeBourse.ReadOnly"
                        color="secondary">
                            Ajouter
                        </v-btn>
                    </v-layout>
                </template>
                <v-form
                ref="form"
                v-model="valid">
                    <v-card>
                        <v-toolbar color="secondary" dark>
                            <v-toolbar-title>Ajouter parcours</v-toolbar-title>
                        </v-toolbar>
                        <v-card-text>
                            <v-container grid-list-md>
                                <v-layout row wrap xs12>
                                    <v-flex>
                                        <v-autocomplete 
                                        label="Année CPGE" 
                                        v-model="editedItem.AnneeCpge"
                                        item-text="lang00"
                                        item-value="id"
                                        :items="$storeCatalogue.AnneeCpge"
                                        clearable
                                        :rules="$storeReglesBourse.obligatoire"
                                        ></v-autocomplete>
                                    </v-flex>
                                    <v-flex>
                                        <v-autocomplete 
                                        label="Année scolaire" 
                                        v-model="editedItem.AnneeScolaire"
                                        item-text="lang00"
                                        item-value="id"
                                        :items="$storeCatalogue.AnneeScolaire"
                                        clearable
                                        :rules="$storeReglesBourse.obligatoire"
                                        ></v-autocomplete>
                                    </v-flex>
                                    <v-flex>
                                        <v-autocomplete 
                                        label="Filière" 
                                        v-model="editedItem.Filiere"
                                        item-text="lang00"
                                        item-value="id"
                                        :items="$storeCatalogue.Filiere"
                                        clearable
                                        :rules="$storeReglesBourse.obligatoire"
                                        ></v-autocomplete>
                                    </v-flex>
                                    <v-flex>
                                        <v-autocomplete
                                            v-model="editedItem.Etablissement"
                                            label="Etablissement CPGE"
                                            :rules="$storeReglesBourse.obligatoire"
                                            item-text="label"
                                            item-value="idCrypte"
                                            :items="$storeDemandeBourse.ListeTousEtablissementsCpge"
                                            clearable
                                            @change="EditedItemEtablissementChange"
                                        ></v-autocomplete>
                                    </v-flex>
                                    <v-flex>
                                        <v-autocomplete 
                                            label="Type établissement" 
                                            v-model="editedItem.TypeEtablissement"
                                            item-text="lang00"
                                            item-value="id"
                                            :items="$storeCatalogue.TypeEtablissement"
                                            disabled
                                        ></v-autocomplete>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn small dark color="secondary" @click="close">Annuler</v-btn>
                            <v-btn small dark color="secondary" @click="save">Valider</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-form>
            </v-dialog>
            <!-- fin dialog -->
        </v-layout>
        <!-- Début Liste langues -->
        <v-data-table :headers="headers" :items="$storeDemandeBourse.DonneesFormulaire.ListeParcoursCpge" class="elevation-1" disable-pagination hide-default-footer>
            <template v-slot:item={item}>
                <tr v-if="!item.Supprimer">
                    <th class="text-xs-left">{{ $storeCatalogue.AffichageCatalogue($storeCatalogue.AnneeCpge, item.AnneeCpge, $storeCommun.ItemLang) }}</th>
                    <th class="text-xs-left">{{ $storeCatalogue.AffichageCatalogue($storeCatalogue.AnneeScolaire, item.AnneeScolaire, $storeCommun.ItemLang) }}</th>
                    <th class="text-xs-left">{{ $storeCatalogue.AffichageCatalogue($storeCatalogue.Filiere, item.Filiere, $storeCommun.ItemLang) }}</th>
                    <th class="text-xs-left">{{ $storeDemandeBourse.NomEtabCpgeParId(item.Etablissement) }}</th>
                    <th class="text-xs-left">{{ $storeCatalogue.AffichageCatalogue($storeCatalogue.TypeEtablissement, item.TypeEtablissement, $storeCommun.ItemLang) }}</th>
                    <th>
                        <v-icon small class="mr-2" @click="editItem(item)" v-show="!$storeDemandeBourse.ReadOnly">{{ icons.mdiPencil }}</v-icon>
                        <v-icon small @click="deleteItem(item)" v-show="!$storeDemandeBourse.ReadOnly">{{ icons.mdiDelete }}</v-icon>
                    </th>
                </tr>
            </template>
        </v-data-table>
    </v-form>
</template>
<script>
    import {
        mdiPencil,
        mdiDelete,
    } from '@mdi/js'
    export default {
        components: {},
        data() {
            return {
                // type etablissement
                TypeEtablissementCpge:null,

                // Icon importés depuis mdi/js pour les icones d'édition/suppression
                  icons: {
                    mdiPencil,
                    mdiDelete,
                },
                // Réaffecter l'objet global pour forcer la maj en temps réel
                $storeCatalogue: this.$storeCatalogue,
                $storeDemandeBourse: this.$storeDemandeBourse,
                $storeReglesBourse: this.$storeReglesBourse,
                $storeCommun : this.$storeCommun,
                // dialog pour ouvrir/fermer la popup
                dialog: false, 

                // Validation du formulaire
                valid : false,
                
                // nom des colonnes
                headers: [
                    { text: 'Année CPGE', value: 'anneecpge' },
                    { text: 'Année scolaire', value: 'anneescolaire' },
                    { text: 'Filière', value: 'filiere' },
                    { text: 'Etablissement CPGE', value: 'etablissementcpge' },
                    { text: 'Type établissement', value: 'typeetablissement' },
                    { text: '', value: 'actions', sortable: false }
                ],

                // index de l'objet édité.
                editedIndex: -1,

                // Item local
                editedItem: {
                    IdCrypte:null,
                    Supprimer:false,
                    AnneeCpge:null, 
                    AnneeScolaire:null, 
                    Filiere:null, 
                    Etablissement:null,
                    TypeEtablissement:null,
                },
            }
        },
        created(){
            // charge la liste des etablissement CPGE
            var self = this;
             Promise.all([
                this.$storeDemandeBourse.EtabCPGE(false)
                .then(response=>{
                    if(response){
                        this.$storeDemandeBourse.ListeEtablissementsCpge = response.data;
                    }
                }),
                this.$storeDemandeBourse.EtabCPGE(true)
                .then(response=>{
                    if(response){
                        this.$storeDemandeBourse.ListeEtablissementsCpgeLydex = response.data;
                    }
                }),
                this.$storeDemandeBourse.TousEtabCPGE()
                .then(response=>{
                    if(response){
                        this.$storeDemandeBourse.ListeTousEtablissementsCpge = response.data;
                    }
                }),
            ])
            .then(function(){
                self.ChargerEtablissementEnCours();
                self.EtablissementCpgeChange();
            });
        },
        computed:{
        },
        methods: {
            ValiderForm(){
                this.$refs.refParcoursCpge.validate()
                let listeErreur =[];
                Object.keys(this.$refs).forEach(key => {
                    if(key != "refParcoursCpge"){
                        if((!this.$refs[key].valid && this.$refs[key].valid != undefined)
                            || (this.$refs[key].valid == undefined
                                && this.$refs[key].$children != undefined
                                && this.$refs[key].$children[0] != undefined 
                                && !this.$refs[key].$children[0].valid)){
                        let label = this.$refs[key].label;
                        if(!label){
                        let inp = this.$refs[key];
                        if(!inp.$attrs){
                            inp = inp[0];
                        }
                        label = inp.$attrs["itemprop"];
                        }
                        if(label && label != undefined)
                        {
                            listeErreur.push(label);
                        }
                    }
                    }
                });
                return listeErreur;
            },
            ChangementAnneeCpge(){
                this.ChargerEtablissementEnCours();
            },
            ChargerEtablissementEnCours(){
                if(this.$storeDemandeBourse.DonneesFormulaire.Programmes.indexOf(this.$storeCatalogue.ProgrammeGemDataId) !== -1){
                    this.$storeDemandeBourse.ListeEtablissementsCpgeEnCours = this.$storeDemandeBourse.ListeEtablissementsCpgeLydex;
                }
                else{
                    this.$storeDemandeBourse.ListeEtablissementsCpgeEnCours = this.$storeDemandeBourse.ListeEtablissementsCpge;
                }
            },
            EtablissementCpgeChange(){
                if(this.$storeDemandeBourse.ListeEtablissementsCpgeEnCours.find((i) => i.idCrypte == this.$storeDemandeBourse.DonneesFormulaire.EtablissementCpge)
                && this.$storeDemandeBourse.ListeEtablissementsCpgeEnCours.find((i) => i.idCrypte == this.$storeDemandeBourse.DonneesFormulaire.EtablissementCpge).typeEtablissement){
                    this.TypeEtablissementCpge = 
                        this.$storeDemandeBourse.ListeEtablissementsCpgeEnCours.find((i) => i.idCrypte == this.$storeDemandeBourse.DonneesFormulaire.EtablissementCpge).typeEtablissement.lang00;
                }
                else{
                    this.TypeEtablissementCpge = null;
                }
            },
            EditedItemEtablissementChange(){
                if(this.$storeDemandeBourse.ListeTousEtablissementsCpge.find((i) => i.idCrypte == this.editedItem.Etablissement)
                && this.$storeDemandeBourse.ListeTousEtablissementsCpge.find((i) => i.idCrypte == this.editedItem.Etablissement).typeEtablissement){
                    this.editedItem.TypeEtablissement = this.$storeDemandeBourse.ListeTousEtablissementsCpge.find((i) => i.idCrypte == this.editedItem.Etablissement).typeEtablissement.id;
                }
                else{
                    this.editedItem.TypeEtablissement = null;
                }
            },

            editItem(item) {
                // Récupère l'item à éditer et l'affecte à editItem local pour remplir les rubriques du formulaire popup.
                this.editedIndex = this.$storeDemandeBourse.DonneesFormulaire.ListeParcoursCpge.indexOf(item)
                this.editedItem = Object.assign({}, item)

                // ouvre le popup
                this.dialog = true
            },
            deleteItem(item) {
                if (confirm("Etes-vous sûr de vouloir supprimer cette ligne?")) {
                    // on récupère l'item depuis le store
                    this.editedIndex = this.$storeDemandeBourse.DonneesFormulaire.ListeParcoursCpge.indexOf(item)
                    // on affecte l'item local pour récupèrer les valeurs
                    this.editedItem = Object.assign({}, item)

                    // on affecte la valeur supprimer à true
                    this.editedItem.Supprimer = true;

                    // on modifie l'item dans le store
                    Object.assign(this.$storeDemandeBourse.DonneesFormulaire.ListeParcoursCpge[this.editedIndex], this.editedItem)

                    // appel le close pour désaffecter l'item local
                    this.close();
                }
            },
            close() {
                this.$refs.form.resetValidation();
                // ferme le popup
                this.dialog = false
                // on remet à zéro le editedItem local
                this.editedItem = Object.assign({}, {
                    IdCrypte:null,
                    Supprimer:false,
                    AnneeCpge:null, 
                    AnneeScolaire:null, 
                    Filiere:null, 
                    Etablissement:null,
                    TypeEtablissement:null,
                });

                this.editedIndex = -1;
            },

            save() {
                // validation du formulaire
                this.$refs.form.validate();
                if(!this.valid){
                    return;
                }
                
                // on passe le item local à false.
                this.editedItem.Supprimer = false;

                // on modifie l'item dans le store si l'editedIndex est renseigné.
                if (this.editedIndex > -1) {
                    Object.assign(this.$storeDemandeBourse.DonneesFormulaire.ListeParcoursCpge[this.editedIndex], this.editedItem)
                }
                // sinon, on ajoute l'item local au store.
                else {
                    this.$storeDemandeBourse.DonneesFormulaire.ListeParcoursCpge.push(this.editedItem)
                }
                this.close();
            },
        },
        mounted(){
            this.$refs.refParcoursCpge.resetValidation();
        },
    }
</script>
<style scoped src="@/assets/css/DemandeBourse.css">
</style>